"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _emotion = require("emotion");
var _reactComponents = require("@cimpress/react-components");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var diagnosticButtonClass = (0, _emotion.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: Transparent;\n  border: none;\n  outline: none;\n  padding: 0px;\n"])));
var diagnosticButtonContentClass = (0, _emotion.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n &:hover {\n        text-decoration: underline;\n      }\n"])));
var DiagnosticButton = function DiagnosticButton(props) {
  var buttonColor = props.disabled ? _reactComponents.colors.alloy : _reactComponents.colors.info.base;
  var buttonCursor = props.disabled ? 'default' : 'pointer';
  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: props.onClick,
    disabled: props.disabled,
    style: {
      color: buttonColor,
      cursor: buttonCursor
    },
    className: diagnosticButtonClass
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
    contents: props.tooltipText
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: diagnosticButtonContentClass
  }, " ", props.children)));
};
DiagnosticButton.propTypes = {
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  tooltipText: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var _default = DiagnosticButton;
exports["default"] = _default;